// @flow
import React, { useState } from 'react';
import styled from 'styled-components';
import { minMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { Button } from '@finect/tabular-core/Button';
import { X } from '@finect/tabular-icons/x';

// Barra inferior fija (móvil/tablet ≤ miniDesktop) que mantiene la captación siempre
// accesible sin ser intrusiva. Aparece al hacer scroll más allá del formulario embebido y
// al pulsarla lleva de vuelta a él (no abre modal). Se puede cerrar.
const Bar = styled.div`
  position: fixed;
  z-index: 1000;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 15px;
  padding-bottom: calc(12px + env(safe-area-inset-bottom));
  background-color: ${({ theme }) => theme.colors.primary};
  box-shadow: 0 -4px 16px -6px rgba(0, 0, 0, 0.35);
  transform: translateY(${({ $visible }) => ($visible ? '0' : '110%')});
  transition: transform 0.25s ease;

  ${minMediaQueries.miniDesktop`
    display: none;
  `};
`;

const BarText = styled.p`
  flex: 1;
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.3;
  color: #fff;
`;

const BarClose = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  padding: 4px;
  border: 0;
  background: transparent;
  color: #fff;
  cursor: pointer;
  opacity: 0.8;

  &:hover {
    opacity: 1;
  }
`;

type Props = {
  visible: boolean,
  onClick: () => void
};

export const LeadBar = ({ visible, onClick }: Props) => {
  const [dismissed, setDismissed] = useState(false);
  if (dismissed) return null;

  return (
    <Bar $visible={visible}>
      <BarText>¿No sabes qué asesor elegir?</BarText>
      <Button
        color="secondary"
        variant="medium"
        width="auto"
        onClick={onClick}
        data-fi-event="landingProvincia-encuentraAsesorMovil"
      >
        Encuentra asesor
      </Button>
      <BarClose type="button" aria-label="Cerrar" onClick={() => setDismissed(true)}>
        <X size="20" />
      </BarClose>
    </Bar>
  );
};
